export default "__VITE_ASSET__BQR0RDS2__"